import { gql, useMutation } from '@apollo/client';

import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../queries/BrokerageLwcDetails';
import { LWC_DETAILS_QUERY } from '../queries/LwcDetails';
import { SetTimestamps, SetTimestampsVariables } from './__generated__/SetTimestamps';

export const SET_LWC_PRODUCT_TIMESTAMPS = gql`
  mutation SetTimestamps($params: OdProtosListingsServices_SetTimestampsRequestInput!) {
    odProtosListingsServicesListwithcertaintyproduct {
      setTimestamps(input: $params) {
        _empty
      }
    }
  }
`;

export const useSetTimestamps = () => {
  const [setLwcProductTimestampsMutation, { data, error, loading }] = useMutation<
    SetTimestamps,
    SetTimestampsVariables
  >(SET_LWC_PRODUCT_TIMESTAMPS, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY],
  });

  const setLwcProductTimestamp = (params: SetTimestampsVariables) =>
    setLwcProductTimestampsMutation({
      variables: params,
    });
  return { setLwcProductTimestamp, data, loading, error };
};
